import React from 'react';
import { Link } from 'react-router-dom';
import BaseGridToolbar from '../../components/shared/toolbar/BaseGridToolbar';
import ToolbarButton from '../../components/shared/toolbar/ToolbarButton';

export function SubmissionListToolbar({
  title = 'Submissions',
  columns,
  data = [],
  type = 'active',
  showQuickFilter,
  quickFilterProps,
}) {
  return (
    <BaseGridToolbar
      title={type === 'active' ? title : 'Submission History'}
      columns={columns}
      data={data}
      showQuickFilter={showQuickFilter}
      quickFilterProps={quickFilterProps}
    />
  );
}
